import React from 'react';
import PropTypes from 'prop-types';
import RavenUtil from '../../../../common/ravenUtil';
import { strings } from 'APP_ROOT/localization';
import Beacon from './Attributes/Beacon';
import ConfirmDialog from 'APP_ROOT/components/common/ConfirmDialog';
import LocationLabel from 'APP_ROOT/components/pages/dashboard/LocationLabel';

export default class AssetBeaconPanel extends React.PureComponent {

    state = {
        confirmDeleteOpen: false,
    }

    openConfirmDeleteDialog = () => {
        this.setState({ confirmDeleteOpen: true });
    }

    closeConfirmDeleteDialog = () => {
        this.setState({ confirmDeleteOpen: false });
    }

    deleteAsset = () => {
        this.props.onDeleteAsset();
        this.setState({ confirmDeleteOpen: false });
    }

    renderGeofences = (currentAsset) => {
        const geofences = this.props.wrapingGeofences(currentAsset.longitude, currentAsset.latitude);

        if (geofences.length === 0) return null;

        const geofencesNames = geofences.map(g => g.name).join(', ');
        return <div className='asset-beacon-detail'>{strings.asset_geofence_label}: {geofencesNames}</div>
    }

    render() {
        const {asset: currentAsset} = this.props;

        const showDeleteButton = currentAsset && currentAsset.assetUuid; // Don't show delete button if assetUuid is not set (creating a new asset)
        const hasBeacon = currentAsset && currentAsset.beaconUuid;
        const location = { lat: currentAsset.latitude, lon: currentAsset.longitude, ts: currentAsset.ts};
        const hasLocation = currentAsset && currentAsset.latitude && currentAsset.longitude && currentAsset.ts;

        return (
            <section className="asset-beacons-panel">

                <header>
                    <Beacon beacons={this.props.availableBeacons} asset={currentAsset} onChange={this.props.onEditAsset} editable={this.props.editable} />
                    <div>
                        {this.props.editable ? // RAV-5501 - Hide buttons for 'viewer' users
                            <>
                            {showDeleteButton && <button disabled={this.props.saving} className="btn btn-red btn-sm mr-1" onClick={this.openConfirmDeleteDialog}>{strings.resource_action_delete_asset}</button>}
                            {currentAsset.editing ?
                            <>
                                <button disabled={this.props.saving} className="btn btn-blue btn-sm mr-1" onClick={this.props.onSaveAssetEdit}>{strings.resource_action_save_asset}</button>
                                <button disabled={this.props.saving} className="btn btn-blue btn-sm" onClick={this.props.onCancelAssetEdit}>{strings.action_cancel}</button>
                            </>
                            :   <button className="btn btn-blue btn-sm" onClick={this.props.onStartAssetEdit}>{strings.resource_action_edit_asset}</button>
                            }
                            </>
                            : null
                }
                    </div>     
                </header>
                <section className='asset-beacon-details'>
                    {hasBeacon ? hasLocation ?
                        <section>
                            <div>
                                <div className='asset-beacon-detail'><label>{strings.asset_battery_label}: </label>{currentAsset.batteryPercentage} %</div>
                                <div className='asset-beacon-detail'><label>{strings.asset_last_seen_label}: </label>{RavenUtil.toDateString(new Date(currentAsset.ts * 1000))}</div>
                                <div className='asset-beacon-detail'><label>{strings.asset_last_seen_by_label}: </label>{`${currentAsset.carPersona} [${currentAsset.enclosureSerialNo}]`}</div>
                            </div>
                            <div>
                                <div className='asset-beacon-detail'><label>{strings.asset_location_label} (lat, lon): </label><a href={`https://maps.google.com/?q=${currentAsset.latitude},${currentAsset.longitude}`} target='_blank' >{currentAsset.latitude}, {currentAsset.longitude}</a></div>
                                <div className='asset-beacon-detail'><label>{strings.asset_address_label}: </label><LocationLabel withStreetNumber={true} addMapLink={false} location={location} /></div>
                                {this.renderGeofences(currentAsset)}
                            </div>
                        </section>
                        : <section><div className='asset-beacon-detail'>{strings.asset_no_data_available}</div> </section>
                        : null
                    }
                    {!hasBeacon &&
                            <div className='onboarding-message'>{strings.asset_assign_beacon_instruction}</div>
                    }
                </section>
                <ConfirmDialog
                    isOpen={this.state.confirmDeleteOpen}
                    onOk={this.deleteAsset}
                    onCancel={this.closeConfirmDeleteDialog}
                    onDismiss={this.closeConfirmDeleteDialog}
                >
                    <h3>{strings.resource_action_delete_asset_confirm_message}</h3>
                    {hasBeacon && <>
                        <p className='text-danger'>
                            <h5 className='text-danger'>{strings.resource_action_delete_asset_assigned_beacon_warning_message}</h5>
                            {strings.resource_action_delete_asset_assigned_beacon_details_message}
                        </p>
                    </>}
                </ConfirmDialog>
                {this.props.errorMessage && <p className="error-message">{this.props.errorMessage}</p>}
            </section>
        )
    }

}

AssetBeaconPanel.propTypes = {
    asset: PropTypes.object,
    saving: PropTypes.bool,
    onEditAsset: PropTypes.func.isRequired,
    onStartAssetEdit: PropTypes.func.isRequired,
    onSaveAssetEdit: PropTypes.func.isRequired,
    onCancelAssetEdit: PropTypes.func.isRequired,
    onDeleteAsset: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

